import ScrollAnimation from "../ScrollAnimation/ScrollAnimation";
import "./SubHeading.css";

const SubHeading = ({ children }) => {
    return (
        <ScrollAnimation className="sub-heading" delay={600}>
            {children}
        </ScrollAnimation>
    );
};

export default SubHeading;
